import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatSnackBarConfig } from "@angular/material";

import { MaterialAppModule } from "../ngmaterial.module";

import { DashboardComponent } from ".";
import { DashboardHomeComponent } from "./home/home.component";
import { AdminGuard, AuthenticateGuard } from "../common/guards";
import { CommonModule } from "../common/common.module";
import { SessionsComponent } from "../sessions";
import { ApplicationsComponent } from "../administrative/applications/applications.component";
import { UsersComponent } from "../administrative/users/users.component";
import { SummaryComponent } from "../administrative/summary/summary.component";
import { NavigationMenuItemComponent } from "./navigationMenuItem/navigation-menu-item.component";
import { GatewaysComponent } from "../administrative/gateways";
import { PrivateGatewayDeactivateGuard } from "../administrative/gateways/private-gateway-deactivate.guard";
import { GatewayDownloadComponent } from "../administrative/gateways/gateway-download/gateway-download.component";
import { ClientAccessComponent } from "../client-access/client-access.component";
import { SamlAliasesComponent } from "../administrative/saml-aliases";
import { PoliciesComponent } from "app/administrative/policies/policies.component";
import { SettingsComponent } from "../user/settings/settings.component";

export const ROUTES: Route[] = [
	{
		path: "administration",
		component: DashboardComponent,
		canActivate: [
			AuthenticateGuard,
			AdminGuard
		],
		children: [
			{
				path: "",
				redirectTo: "home",
				pathMatch: "full",
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "home",
				component: SummaryComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "settings",
				component: SettingsComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "applications",
				component: ApplicationsComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "policies",
				component: PoliciesComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "users",
				component: UsersComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "samlalias",
				component: SamlAliasesComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "sessions",
				redirectTo: "sessions/all",
				pathMatch: "full"
			},
			{
				path: "sessions/:status",
				component: SessionsComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "gateways",
				redirectTo: "gateways/setup",
				pathMatch: "full"
			},
			{
				path: "gateways/download",
				component: GatewayDownloadComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			},
			{
				path: "gateways/setup",
				component: GatewaysComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				canDeactivate: [
					PrivateGatewayDeactivateGuard
				]
			},
			{
				path: "clients",
				component: ClientAccessComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				]
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		MaterialAppModule,
		CommonModule
	],
	declarations: [
		DashboardComponent,
		DashboardHomeComponent,
		NavigationMenuItemComponent
	],
	entryComponents: [
	],
	providers: [
		MatSnackBarConfig
	],
	exports: [
		DashboardComponent,
		DashboardHomeComponent
	]
})
export class DashboardModule { }
